import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { AppRoutes } from '../routes';
import { MODAL_TOKEN, ModalProvider } from '../tokens/modal.token';
import { NAVIGATION_TOKEN, NavigationProvider } from '../tokens/navigation.token';

@Injectable({ providedIn: 'root' })
export class AppNativeEventsService {
  private readonly router: Router = inject(Router);
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);
  private readonly navigationProvider: NavigationProvider = inject(NAVIGATION_TOKEN);

  private backButtonPressedOnce: boolean = false;

  init(): void {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    this.handleBackButton();
  }

  private handleBackButton(): void {
    App.addListener('backButton', () => {
      if (this.modalProvider.isModalActive()) {
        this.modalProvider.dismissAllStoredModals();
        return;
      }
      if (this.isOnRootRoute()) {
        this.handleRootBackButton();
        return;
      }
      this.navigationProvider.back();
    });
  }

  private isOnRootRoute(): boolean {
    const url: string = this.router.url;
    return url === '/' || url.startsWith(`/${AppRoutes.TODAY}`);
  }

  private handleRootBackButton(): void {
    if (this.backButtonPressedOnce) {
      App.exitApp();
      return;
    }
    this.backButtonPressedOnce = true;
    setTimeout(() => {
      this.backButtonPressedOnce = false;
    }, 500);
  }
}
